import { FootballPerformanceCategory } from '../../enums/football-performance-category.enum';

export const FOOTBALL_PERFORMANCE_CATEGORY_BY_MARKET: Record<string, FootballPerformanceCategory> =
	{
		Moneyline: FootballPerformanceCategory.GameOutcome,
		'1st Half Moneyline': FootballPerformanceCategory.GameOutcome,
		'2nd Half Moneyline': FootballPerformanceCategory.GameOutcome,
		'1st Quarter Moneyline': FootballPerformanceCategory.GameOutcome,
		'2nd Quarter Moneyline': FootballPerformanceCategory.GameOutcome,
		'3rd Quarter Moneyline': FootballPerformanceCategory.GameOutcome,
		'4th Quarter Moneyline': FootballPerformanceCategory.GameOutcome,
		'Point Spread': FootballPerformanceCategory.GameOutcome,
		'1st Half Point Spread': FootballPerformanceCategory.GameOutcome,
		'2nd Half Point Spread': FootballPerformanceCategory.GameOutcome,
		'1st Quarter Point Spread': FootballPerformanceCategory.GameOutcome,
		'2nd Quarter Point Spread': FootballPerformanceCategory.GameOutcome,
		'3rd Quarter Point Spread': FootballPerformanceCategory.GameOutcome,
		'4th Quarter Point Spread': FootballPerformanceCategory.GameOutcome,

		'Total Points': FootballPerformanceCategory.Scoring,
		'Total Points Odd/Even': FootballPerformanceCategory.Scoring,
		'1st Half Total Points': FootballPerformanceCategory.Scoring,
		'1st Half Total Points Odd/Even': FootballPerformanceCategory.Scoring,
		'2nd Half Total Points': FootballPerformanceCategory.Scoring,
		'2nd Half Total Points Odd/Even': FootballPerformanceCategory.Scoring,
		'1st Quarter Total Points': FootballPerformanceCategory.Scoring,
		'1st Quarter Total Points Odd/Even': FootballPerformanceCategory.Scoring,
		'2nd Quarter Total Points': FootballPerformanceCategory.Scoring,
		'3rd Quarter Total Points': FootballPerformanceCategory.Scoring,
		'4th Quarter Total Points': FootballPerformanceCategory.Scoring,
		'Total Touchdowns': FootballPerformanceCategory.Scoring,
		'1st Quarter Total Touchdowns': FootballPerformanceCategory.Scoring,
		'2nd Quarter Total Touchdowns': FootballPerformanceCategory.Scoring,
		'3rd Quarter Total Touchdowns': FootballPerformanceCategory.Scoring,
		'4th Quarter Total Touchdowns': FootballPerformanceCategory.Scoring,
		'1st Half Total Touchdowns': FootballPerformanceCategory.Scoring,
		'2nd Half Total Touchdowns': FootballPerformanceCategory.Scoring,

		'Team Total': FootballPerformanceCategory.Scoring,
		'Team Total Points Odd/Even': FootballPerformanceCategory.Scoring,
		'Team Total Touchdowns': FootballPerformanceCategory.Scoring,
		'1st Quarter Team Total': FootballPerformanceCategory.Scoring,
		'1st Quarter Team Total Points Odd/Even': FootballPerformanceCategory.Scoring,
		'1st Half Team Total': FootballPerformanceCategory.Scoring,
		'1st Half Team Total Points Odd/Even': FootballPerformanceCategory.Scoring,
		'2nd Half Team Total': FootballPerformanceCategory.Scoring,
		'2nd Half Team Total Points Odd/Even': FootballPerformanceCategory.Scoring,

		'First Team To Score': FootballPerformanceCategory.Drives,
		'Last Team To Score': FootballPerformanceCategory.Drives,

		'Player Passing Yards': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Attempts': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Completions': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Touchdowns': FootballPerformanceCategory.QuarterbackPlay,
		'Player Longest Passing Completion': FootballPerformanceCategory.QuarterbackPlay,
		'1st Quarter Player Passing Yards': FootballPerformanceCategory.QuarterbackPlay,
		'1st Half Player Passing Yards': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Yards Each Half': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Yards Each Quarter': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Yards (Either)': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Yards H2H Spread': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Yards (Combo)': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing + Rushing Yards': FootballPerformanceCategory.QuarterbackPlay,
		'Player Passing Yards H2H Moneyline': FootballPerformanceCategory.QuarterbackPlay,

		'Player Rushing Yards': FootballPerformanceCategory.RushingReceiving,
		'Player Rushing Attempts': FootballPerformanceCategory.RushingReceiving,
		'1st Quarter Player Rushing Yards': FootballPerformanceCategory.RushingReceiving,
		'Player Rushing Yards Each Quarter': FootballPerformanceCategory.RushingReceiving,
		'Player Rushing Yards Each Half': FootballPerformanceCategory.RushingReceiving,
		'Player Rushing + Receiving Yards': FootballPerformanceCategory.RushingReceiving,
		'1st Quarter Player Rushing + Receiving Yards': FootballPerformanceCategory.RushingReceiving,
		'1st Half Player Rushing Yards': FootballPerformanceCategory.RushingReceiving,
		'1st Quarter Player Rushing Attempts': FootballPerformanceCategory.RushingReceiving,
		'Player Rushing Yards (Combo)': FootballPerformanceCategory.RushingReceiving,
		'Player Rushing Yards H2H Moneyline': FootballPerformanceCategory.RushingReceiving,
		'Player Rushing Yards H2H Spread': FootballPerformanceCategory.RushingReceiving,

		'Player Receiving Yards': FootballPerformanceCategory.RushingReceiving,
		'Player Receptions': FootballPerformanceCategory.RushingReceiving,
		'1st Half Player Receiving Yards': FootballPerformanceCategory.RushingReceiving,
		'1st Quarter Player Receiving Yards': FootballPerformanceCategory.RushingReceiving,
		'1st Quarter Player Receptions': FootballPerformanceCategory.RushingReceiving,
		'Player Receiving Yards Each Quarter': FootballPerformanceCategory.RushingReceiving,
		'Player Receiving Yards (Either)': FootballPerformanceCategory.RushingReceiving,
		'Player Receiving Yards H2H Spread': FootballPerformanceCategory.RushingReceiving,
		'Player Receiving Yards (Combo)': FootballPerformanceCategory.RushingReceiving,
		'Player Receiving Yards H2H Moneyline': FootballPerformanceCategory.RushingReceiving,

		'Player Touchdowns': FootballPerformanceCategory.Scoring,
		'Player Touchdowns (Combo)': FootballPerformanceCategory.Scoring,
		'Player Touchdowns (Either)': FootballPerformanceCategory.Scoring,

		'Player Field Goals Made': FootballPerformanceCategory.Scoring,
		'Player Extra Points Made': FootballPerformanceCategory.Scoring,
		'Player Kicking Points': FootballPerformanceCategory.Scoring,
		'Player Sacks': FootballPerformanceCategory.GameOutcome,
		'Player Tackles': FootballPerformanceCategory.GameOutcome,
		'Player Tackles + Assists': FootballPerformanceCategory.GameOutcome,
		'Player Interceptions': FootballPerformanceCategory.GameOutcome,

		'Anytime Touchdown Scorer': FootballPerformanceCategory.Scoring,
		'First Touchdown Scorer': FootballPerformanceCategory.Scoring,
		'Last Touchdown Scorer': FootballPerformanceCategory.Scoring,
		'1st Quarter Anytime Touchdown Scorer': FootballPerformanceCategory.Scoring,
		'1st Quarter Player Touchdowns': FootballPerformanceCategory.Scoring,
		'1st Half Anytime Touchdown Scorer': FootballPerformanceCategory.Scoring,
		'2nd Half Anytime Touchdown Scorer': FootballPerformanceCategory.Scoring,
		'1st Half Player Touchdowns': FootballPerformanceCategory.Scoring,
		'2nd Half Player Touchdowns': FootballPerformanceCategory.Scoring,

		'Correct Score': FootballPerformanceCategory.Drives,
		'1st Quarter Correct Score': FootballPerformanceCategory.Drives,
		'1st Half Correct Score': FootballPerformanceCategory.Drives,
		'Both Teams To Score': FootballPerformanceCategory.Drives,
		'Both Teams Total Points': FootballPerformanceCategory.Drives,

		'Race to 5 Points': FootballPerformanceCategory.Scoring,
		'Race to 6 Points': FootballPerformanceCategory.Scoring,
		'Race to 9 Points': FootballPerformanceCategory.Scoring,
		'Race to 10 Points': FootballPerformanceCategory.Scoring,
		'Race to 12 Points': FootballPerformanceCategory.Scoring,
		'Race to 15 Points': FootballPerformanceCategory.Scoring,
		'Race to 20 Points': FootballPerformanceCategory.Scoring,
		'Race to 25 Points': FootballPerformanceCategory.Scoring,
		'Race to 30 Points': FootballPerformanceCategory.Scoring,
		'Race to 35 Points': FootballPerformanceCategory.Scoring,

		'Will There Be Overtime': FootballPerformanceCategory.GameOutcome,
		'Halftime / Fulltime': FootballPerformanceCategory.Drives,
		'Will There Be A Safety': FootballPerformanceCategory.Scoring,
	};

export const FOOTBALL_PERFORMANCE_CATEGORY_BY_SEEDED_CATEGORY: Record<
	string,
	FootballPerformanceCategory
> = {
	Moneyline: FootballPerformanceCategory.GameOutcome,
	Spread: FootballPerformanceCategory.GameOutcome,
	'Game Total': FootballPerformanceCategory.Scoring,
	'Team Total': FootballPerformanceCategory.Scoring,
	'Player Passing Props': FootballPerformanceCategory.QuarterbackPlay,
	'Player Receiving Props': FootballPerformanceCategory.RushingReceiving,
	'Player Rushing Props': FootballPerformanceCategory.RushingReceiving,
	'Player Touchdowns Props': FootballPerformanceCategory.Scoring,
	'Player Kicking / Defensive Props': FootballPerformanceCategory.Scoring,
	'Race To X Points': FootballPerformanceCategory.Scoring,
	'Scoring / Team Events': FootballPerformanceCategory.Drives,
	Miscellaneous: FootballPerformanceCategory.GameOutcome,
	'Special Game Events': FootballPerformanceCategory.GameOutcome,
};
